export const macModelUrls = {
  "UPPER FRONT VIEW|Headrest": [
    "/Config1/Dress_Covers/Seat_Front-Headrest/2_Way_Headrest_Assy/headrest.glb",
    "/Config1/Dress_Covers/Seat_Front-Headrest/4_Way_Headrest_Assy/headrest.glb",
  ],
  "UPPER FRONT VIEW|Backseat Cushion|Backseat Cushion Colour": [
    "/Config1/Dress_Covers/Seat_Front-Seat_Back/Seat_Back_Dress_Cvr_Assy/01/backseat_cushion.glb",
    "/Config1/Dress_Covers/Seat_Front-Seat_Back/Seat_Back_Dress_Cvr_Assy/02/backseat_cushion.glb",
    "/Config1/Dress_Covers/Seat_Front-Seat_Back/Seat_Back_Dress_Cvr_Assy/03/backseat_cushion.glb",
  ],
  "UPPER FRONT VIEW|Belts": [
    "/Config1/Dress_Covers/Seat_Front-Seat_Pan/Safety_Belt_Assy/belts.glb",
  ],
  "UPPER FRONT VIEW|Buckle": [
    "/Config1/Dress_Covers/Seat_Front-Seat_Pan/Safety_Belt_Assy/buckle.glb",
  ],
  "UPPER FRONT VIEW|Armrest Cap Colour": [
    "/Config1/Living_space/Aisle_Way/Armrest_Assy/armrest_cap.glb",
  ],
  "UPPER FRONT VIEW|Armrest Pan Colour": [
    "/Config1/Living_space/Aisle_Way/Armrest_Assy/armrest_pan.glb",
  ],
  "UPPER FRONT VIEW|Recline Button": [
    "/Config1/Living_space/Aisle_Way/Armrest_Assy/recline_button.glb",
  ],
  "LOWER FRONT VIEW|Seat Cushion|Cushion Colour": [
    "/Config1/Dress_Covers/Seat_Front-Seat_Pan/Seat_Pan_Dress_Cvr_Assy/01/seat_cushion.glb",
    "/Config1/Dress_Covers/Seat_Front-Seat_Pan/Seat_Pan_Dress_Cvr_Assy/02/seat_cushion.glb",
    "/Config1/Dress_Covers/Seat_Front-Seat_Pan/Seat_Pan_Dress_Cvr_Assy/03/seat_cushion.glb",
  ],
  "LOWER FRONT VIEW|Bumpers Colour": [
    "/Config1/Living_space/Aisle_Way/End_Bay_Assy/bumpers.glb",
  ],
  "LOWER FRONT VIEW|Bagage Bar Colour": [
    "/Config1/Living_space/Brightwork/bagage_bar.glb",
  ],
  "LOWER FRONT VIEW|Legs Colour": ["/Config1/Living_space/Brightwork/legs.glb"],
  "LOWER FRONT VIEW|Seat Misc": [
    "/Config1/Living_space/Brightwork/seat_misc.glb",
  ],
  "LOWER FRONT VIEW|Spreaders": [
    "/Config1/Living_space/Brightwork/spreaders.glb",
  ],
  "LOWER BACK VIEW|Lower Lit Pocket": [
    "/Config1/Living_space/Seat_Back_Features_Lower/Lower_Lit_Pocket_Assy/01/pocket.glb",
    "/Config1/Living_space/Seat_Back_Features_Lower/Lower_Lit_Pocket_Assy/02/pocket.glb",
    "/Config1/Living_space/Seat_Back_Features_Lower/Lower_Lit_Pocket_Assy/03/pocket.glb",
  ],
  "UPPER BACK VIEW|Tray|Tray Colour": [
    "/Config1/Living_space/Seat_Back_Features_Mid/Meal_Tray_Assy/meal_table.glb",
    "/Config1/Living_space/Seat_Back_Features_Mid/Bi-fold_Meal_Tray_Assy/meal_table.glb",
  ],
  "UPPER BACK VIEW|Rear Upper Bezel": [
    "/Config1/Living_space/Seat_Back_Features_Upper/Rear_Upper_Bezel_IFE_Assy/rear_upper_bezel.glb",
    "/Config1/Living_space/Seat_Back_Features_Upper/Rear_Upper_Bezel_ULP_TH_Assy/rear_upper_bezel.glb",
  ],
};

export const phoModelUrls = {
  /// BASE GLBS
  "": [
    "/[SEATCODE]/armcap__~Met~Alu-Anodiz~__default.glb",
    "/[SEATCODE]/lowerShroud__~Met~Alu-Anodiz~__default.glb",
    "/[SEATCODE]/lowerShroud__~Pla~Mat-MP31256~__default.glb",
    "/[SEATCODE]/seatBelt__~Met~Alu-Anodiz~__default.glb",
    "/[SEATCODE]/seatBelt__~webbing~__default.glb",
    "/[SEATCODE]/upperShroud__~Pla~Mat-MP19911~__default.glb",
    "/[SEATCODE]/litteraturePocket__~Magazines~__default.glb",
    "/43_Food_Tray/foodTray__~Met~Alu-Anodiz~__block.glb",
  ],

  "VIDEO BAZEL|Backshell Surface|Backshell Surface|Backshell Color|Backshell Color":
    [
      "/[SEATCODE]/rearOuterSurface__~Pla~Mat-MP19911~__default.glb",
      "/[SEATCODE]/rearOuterSurface__~embossed~__block.glb",
    ],

  "BLACK METALWORK|Onyx Metal|Onyx Metal": [
    "/[SEATCODE]/brightwork__~Met~Alu-Anodiz~__default.glb",
    "/[SEATCODE]/brightwork__~Met~Alu-Anodiz~__block.glb",
    "/[SEATCODE]/brightwork__~Met~Alu-BlackAnodiz~__block.glb",
    "/empty.glb",
  ],

  "ATTENDANT STEP|Step Color|Attendant Step|Attendant Step|Attendant Step": [
    "/265_Flight_Attendant_Step/flightAttendantStep_MetAlu_default.glb",
    "/265_Flight_Attendant_Step/flightAttendantStep_NoHole_MetAlu_default.glb",
    "/265_Flight_Attendant_Step/flightAttendantStep_MetBlackAlu_default.glb",
    "/265_Flight_Attendant_Step/flightAttendantStep_NoHole_MetBlackAlu_default.glb",
  ],

  "ARMREST|Perrone Cap|Armcap Material|Armcap Color|Armcap Color": [
    "/[SEATCODE]/armcap__~Leath~Perr-Sky~__block.glb",
    "/[SEATCODE]/armcap__~Leath~Perr-feathW~__block.glb",
    "/[SEATCODE]/armcap__~Leath~Perr-Eli~__block.glb",
  ],

  "ARMREST|Muirhead Cap|Armcap Material|Armcap Color|Armcap Color": [
    "/[SEATCODE]/armcap__~Leath~Muir-DFs~__block.glb",
    "/[SEATCODE]/armcap__~Leath~Muir-DLs~__block.glb",
  ],

  "ARMREST|Faux Leather Cap|Armcap Material|Armcap Color|Armcap Color": [
    "/[SEATCODE]/armcap__~simLeath~Tapi-Faw~__block.glb",
  ],
  "END BAY|Upper Shell Color|Upper Shell Color": [
    "/[SEATCODE]/upperShroud__~Pla~Mat-MP19911~__default.glb",
    "/[SEATCODE]/halfShell__~Pla~Mat-MP19911~__default.glb",
    "/[SEATCODE]/dualPocket__~Pla~Mat-MP19911~__default.glb",
  ],

  "END BAY|Lower Shell Color|Lower Shell Color": [
    "/[SEATCODE]/lowerShroud__~Pla~Mat-MP31256~__default.glb",
    "/[SEATCODE]/consoleStowage__~Pla~Mat-MP31256~__default.glb",
  ],

  "FOOD TRAY|Inlay Material|Tray Inlay|Inlay Color|Inlay Color": [
    "/43_Food_Tray/foodTray__~Pla~DiNo-DW2215~__block.glb",
    "/43_Food_Tray/foodTray__~Pla~Mat-MP19911~__block.glb",
    "/[SEATCODE]/armcap__~Pla~DiNo-DW2215~__default.glb",
    "/[SEATCODE]/armcap__~Pla~Mat-MP19911~__default.glb",
  ],

  "FOOD TRAY|PED Holder|PED Holder": [
    "/43_PED_Holder/pedHolder__~Met~Alu-Anodiz~__default.glb",
  ],

  "FOOD TRAY|PED Holder|PED Holder|Inlay Material|Tray Inlay|Inlay Color|Inlay Color":
    [
      "/43_PED_Holder/pedHolder__~Pla~DiNo-DW2215~__block.glb",
      "/43_PED_Holder/pedHolder__~Pla~Mat-MP19911~__block.glb",
    ],

  "KICK PANEL|Trim Color|Trim Color": [
    "/[SEATCODE]/lowerZoneTrim__~Pla~Mat-MP19911~__block.glb",
  ],

  // "KICK PANEL|Panel Fabric|Kick Panel|Trim Color|Trim Color": [
  //   "/[SEATCODE]/lowerZoneTrim__~Fab~Rohi-NovParad~__block.glb",
  //   "/[SEATCODE]/lowerZoneTrim__~Fab~Bot-generic~__block.glb",
  // ],

  // "KICK PANEL|Perrone Panel|Kick Panel|Trim Color|Trim Color": [
  //   "/[SEATCODE]/lowerZoneTrim__~Leath~Perr-Eli~__block.glb",
  //   "/[SEATCODE]/lowerZoneTrim__~Leath~Perr-feathW~__block.glb",
  //   "/[SEATCODE]/lowerZoneTrim__~Leath~Perr-Sky~__block.glb",
  // ],
  // "KICK PANEL|Muirhead Panel|Kick Panel|Trim Color|Trim Color": [
  //   "/[SEATCODE]/lowerZoneTrim__~Leath~Muir-DFs~__block.glb",
  //   "/[SEATCODE]/lowerZoneTrim__~Leath~Muir-DLs~__block.glb",
  // ],

  "LITERATURE POCKET|Literature Lining Color|Literature Lining Color": [
    "/[SEATCODE]/halfShell__~simLeath~Tapi-Faw~__default.glb",
  ],

  "LITERATURE POCKET|Pocket Fabric|Literature Pocket|Pocket Color|Literature Pocket":
    [
      "/LiteraturePocket_Large/litteraturePocket__~Fab~Rohi-NovParad~__block.glb",
      "/LiteraturePocket_Large/litteraturePocket__~Fab~Bot-generic~__block.glb",
    ],

  "LITERATURE POCKET|Perrone Pocket|Literature Pocket|Pocket Color|Literature Pocket":
    [
      "/LiteraturePocket_Large/litteraturePocket__~Leath~Perr-Sky~__block.glb",
      "/LiteraturePocket_Large/litteraturePocket__~Leath~Perr-Eli~__block.glb",
      "/LiteraturePocket_Large/litteraturePocket__~Leath~Perr-feathW~__block.glb",
    ],

  "LITERATURE POCKET|Muirhead Pocket|Literature Pocket|Pocket Color|Literature Pocket":
    [
      "/LiteraturePocket_Large/litteraturePocket__~Leath~Muir-DFs~__block.glb",
      "/LiteraturePocket_Large/litteraturePocket__~Leath~Muir-DLs~__block.glb",
    ],

  "LITERATURE POCKET|Tapis Pocket|Literature Pocket|Pocket Color|Literature Pocket":
    [
      "/LiteraturePocket_Large/litteraturePocket__~simLeath~Tapi-Faw~__block.glb",
    ],

  "LITERATURE POCKET|Pocket Material|Literature Pocket|Pocket Color|Literature Pocket":
    [
      "/empty.glb",
      "/LiteraturePocket_Large/litteraturePocket__~Pla~Mat-MP19911~__block.glb",
    ],

  "LITERATURE POCKET|Pocket Net|Pocket Net|Pocket Net Color|Pocket Net": [
    "/empty.glb",
    "/LiteraturePocket_Large/litteraturePocket__~Synt~Elastic-Net~__default.glb",
  ],

  "PRIVACY & STOWAGE|Consol Stowage|Consol Stowage": [
    "/276_Collins_Insert/consoleStowage__~foodflyers~__default.glb",
    "/276_Collins_Insert/consoleStowage__~simLeath~Tapi-UlGraph~__default.glb",
    "/276_Collins_Insert/consoleStowage__~Pla~Mat-MP19911~__default.glb",
    "/273_Center_Console_Stowage/consoleStowage__~simLeath~Tapi-UlGraph~__default.glb",
  ],

  "PRIVACY & STOWAGE|Stowage Color|Stowage Color": [
    "/276_Collins_Insert/consoleStowage__~simLeath~Tapi-UlGraph~__default.glb",
    "/276_Collins_Insert/consoleStowage__~Pla~Mat-MP19911~__default.glb",
    "/273_Center_Console_Stowage/consoleStowage__~simLeath~Tapi-UlGraph~__default.glb",
  ],

  "BACK EQUIPMENT|IFE|IFE": [
    "/empty.glb",
    "/223_IFE/IFE__~Splashscreens~__default.glb",
    "/223_IFE/ifeStandard__~plastic~__default.glb",
  ],

  "BACK EQUIPMENT|IFE Type|IFE": [
    "/224_Panasonic_IFE/IFE__~Splashscreens~__default.glb",
    "/224_Panasonic_IFE/ifePanasonic__~plastic~__default.glb",
    "/225_Thales_IFE/IFE__~Splashscreens~__default.glb",
    "/225_Thales_IFE/ifeThales__~plastic~__default.glb",
    "/226_SPI_IFE/IFE__~Splashscreens~__default.glb",
    "/226_SPI_IFE/ifeSPI__~plastic~__default.glb",
  ],

  "BACK EQUIPMENT|Amenities Lining Color|Amenities Lining Color": [
    "/[SEATCODE]/midLevelAmenPocket__~simLeath~Tapi-Faw~__default.glb",
  ],

  // "BACK EQUIPMENT|Custom Pocket|Custom Pocket": [
  //   "/empty.glb",
  //   "/227_mid_Level_Amenities_Pocket/midLevelAmenPocket__~Synt~Elastic-Net~__default.glb",
  // ],

  "BACK EQUIPMENT|Cocktail Table|Cocktail Table": [
    "/empty.glb",
    "/256_Cocktail_Table/cocktableTable__~Pla~Mat-MP19911~__default.glb",
  ],

  "BACK EQUIPMENT|Cocktail Table|Cocktail Table|Aft Color|Aft Color": [
    "/256_Cocktail_Table/cocktableTable__~Pla~Mat-MP19952~__default.glb",
    "/256_Cocktail_Table/cocktableTable__~Met~Alu-Anodiz~__default.glb",
  ],

  //
  "BACK EQUIPMENT|Cocktail Table|Cocktail Table|Tower Type|Tower Type|Amenities Lining Color|Amenities Lining Color":
    [
      //
      "/256_Cocktail_Table/cocktableTable__~simLeath~Tapi-Faw~__default.glb",
      //
    ],

  "BACK EQUIPMENT|Cocktail Table Inlay|Cocktail Table|Cocktail Table Inlay Color|Cocktail Table|Cocktail Table|Cocktail Table":
    [
      "/256_Cocktail_Table/cocktableTable__~Pla~DiNo-DW2215~__block.glb",
      "/256_Cocktail_Table/cocktableTable__~Pla~Mat-MP19911~__block.glb",
      "/empty.glb",
    ],

  "BACK EQUIPMENT|Tower Type|Tower Type|Aft Color|Aft Color": [
    //
    "/Backshell_default/aftTower__~Pla~Mat-MP19911~__default.glb",
    //
  ],

  "BACK EQUIPMENT|Aft Color|Aft Color": [
    "/[SEATCODE]/aftTower__~Pla~Mat-MP19911~__default.glb",
    // "/Backshell_default/aftTower__~Pla~Mat-MP19911~__default.glb",
  ],

  "BACK EQUIPMENT|Coat Hook|Coat Hook|Coat Hook Color|Coat Hook": [
    "/empty.glb",
    "/261_Coat_Hook/coatHook__~Pla~Mat-MP19952~__default.glb",
  ],

  "OPTIONS|Wireless Power|Wireless Power": [
    "/empty.glb",
    "/308_Wireless_Charger/consoleStowage__~foodflyers~__default.glb",
    "/308_Wireless_Charger/consoleStowage__~phone~__default.glb",
    // "/308_Wireless_Charger/consoleStowage__~simLeath~Tapi-UlGraph~__default.glb",
    "/308_Wireless_Charger/consoleStowage__~Pla~Mat-MP19911~__default.glb",
  ],

  "OPTIONS|Wireless Power|Wireless Power|Wireless Power Color|Wireless Power": [
    "/308_Wireless_Charger/consoleStowage__~simLeath~Tapi-UlGraph~__default.glb",
  ],

  "PRIVACY & STOWAGE|Divider Type|Privacy Divider|Tower Color|Tower Color": [
    "/215_Full_Height/privacyDivider__~simLeath~Tapi-Faw~__default.glb",
    "/216_Flag_Style/privacyDivider__~simLeath~Tapi-Faw~__default.glb",
    "/217_Sliding_Divider/privacyDivider__~simLeath~Tapi-Faw~__default.glb",
  ],

  "PRIVACY & STOWAGE|Divider Type|Privacy Divider": [
    "/217_Sliding_Divider/privacyDivider__~Pla~Mat-MP31256~__default.glb",
  ],

  "PRIVACY & STOWAGE|Divider Inlay|Privacy Divider|Divider Inlay Color|Privacy Divider|Divider Type|Privacy Divider":
    [
      "/217_Sliding_Divider/privacyDivider__~Diel~RefractiveR~__block.glb",
      "/217_Sliding_Divider/privacyDivider__~Pla~DiNo-DW2215~__block.glb",
    ],

  "PRIVACY & STOWAGE|Privacy Divider|Privacy Divider|Tower Color|Tower Color": [
    // "/214_Privacy_Divider/privacyDivider__~simLeath~Tapi-Faw~__default.glb", // Old no privacy divider option
    "/214_Privacy_Divider/privacyDividerFlat__~simLeath~Tapi-Faw~__default.glb", // New no privacy divider option (flat)
    "/empty.glb",
  ],

  "PRIVACY & STOWAGE|Reading Light|Privacy Divider": [
    "/218_Accent_Reading_Light/readingLight__~Pla~Mat-MP19952~__default.glb",
    "/empty.glb",
  ],

  "BACK COVER|Back Mono Primary Color|Back Cover Style": [
    "/405_MonoTone_BackCover_DS/backDressCoverDS__~Fab~Bot-generic~__block.glb",
    "/405_MonoTone_BackCover_DS/backDressCoverDS__~Fab~Rohi-NovParad~__block.glb",
    "/405_MonoTone_BackCover_DS/backDressCoverDS__~Leath~Perr-Sky~__block.glb",
    "/405_MonoTone_BackCover_DS/backDressCoverDS__~Leath~Perr-feathW~__block.glb",
    "/405_MonoTone_BackCover_DS/backDressCoverDS__~Leath~Perr-Eli~__block.glb",
    "/405_MonoTone_BackCover_DS/backDressCoverDS__~Leath~Muir-DFs~__block.glb",
    "/405_MonoTone_BackCover_DS/backDressCoverDS__~Leath~Muir-DLs~__block.glb",
    "/405_MonoTone_BackCover_DS/backDressCoverDS__~simLeath~Tapi-UlGraph~__block.glb",
  ],

  "BACK COVER|Back Dual Primary Color|Back Cover Style": [
    "/401_DualTone_BackCover_DS/backDressCoverDS__~Fab~Bot-generic~__blockP.glb",
    "/401_DualTone_BackCover_DS/backDressCoverDS__~Fab~Rohi-NovParad~__blockP.glb",
    "/401_DualTone_BackCover_DS/backDressCoverDS__~Leath~Perr-Sky~__blockP.glb",
    "/401_DualTone_BackCover_DS/backDressCoverDS__~Leath~Perr-feathW~__blockP.glb",
    "/401_DualTone_BackCover_DS/backDressCoverDS__~Leath~Perr-Eli~__blockP.glb",
    "/401_DualTone_BackCover_DS/backDressCoverDS__~Leath~Muir-DFs~__blockP.glb",
    "/401_DualTone_BackCover_DS/backDressCoverDS__~Leath~Muir-DLs~__blockP.glb",
    "/401_DualTone_BackCover_DS/backDressCoverDS__~simLeath~Tapi-UlGraph~__blockP.glb",
  ],

  "BACK COVER|Back Dual Secondary Color|Back Cover Style": [
    "/401_DualTone_BackCover_DS/backDressCoverDS__~Fab~Bot-generic~__blockS.glb",
    "/401_DualTone_BackCover_DS/backDressCoverDS__~Fab~Rohi-NovParad~__blockS.glb",
    "/401_DualTone_BackCover_DS/backDressCoverDS__~Leath~Perr-Sky~__blockS.glb",
    "/401_DualTone_BackCover_DS/backDressCoverDS__~Leath~Perr-feathW~__blockS.glb",
    "/401_DualTone_BackCover_DS/backDressCoverDS__~Leath~Perr-Eli~__blockS.glb",
    "/401_DualTone_BackCover_DS/backDressCoverDS__~Leath~Muir-DFs~__blockS.glb",
    "/401_DualTone_BackCover_DS/backDressCoverDS__~Leath~Muir-DLs~__blockS.glb",
    "/401_DualTone_BackCover_DS/backDressCoverDS__~simLeath~Tapi-UlGraph~__blockS.glb",
  ],

  "BOTTOM COVER|Bottom Decorative Stitch|Bottom Decorative Stitch": [
    "/empty.glb",
    "/408_MonoTone_BottomCover_DS/bottomDressCover__~stitchingThread~__default.glb",
  ],

  "BOTTOM COVER|Bottom Mono Primary Color|Bottom Cover Style": [
    "/408_MonoTone_BottomCover_DS/bottomDressCoverDS__~Fab~Bot-generic~__block.glb",
    "/408_MonoTone_BottomCover_DS/bottomDressCoverDS__~Fab~Rohi-NovParad~__block.glb",
    "/408_MonoTone_BottomCover_DS/bottomDressCoverDS__~Leath~Perr-Sky~__block.glb",
    "/408_MonoTone_BottomCover_DS/bottomDressCoverDS__~Leath~Perr-feathW~__block.glb",
    "/408_MonoTone_BottomCover_DS/bottomDressCoverDS__~Leath~Perr-Eli~__block.glb",
    "/408_MonoTone_BottomCover_DS/bottomDressCoverDS__~Leath~Muir-DFs~__block.glb",
    "/408_MonoTone_BottomCover_DS/bottomDressCoverDS__~Leath~Muir-DLs~__block.glb",
    "/408_MonoTone_BottomCover_DS/bottomDressCoverDS__~simLeath~Tapi-UlGraph~__block.glb",
  ],

  "BOTTOM COVER|Bottom Dual Primary Color|Bottom Cover Style": [
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~Fab~Bot-generic~__blockP.glb",
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~Fab~Rohi-NovParad~__blockP.glb",
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~Leath~Perr-Sky~__blockP.glb",
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~Leath~Perr-feathW~__blockP.glb",
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~Leath~Perr-Eli~__blockP.glb",
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~Leath~Muir-DFs~__blockP.glb",
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~Leath~Muir-DLs~__blockP.glb",
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~simLeath~Tapi-UlGraph~__blockP.glb",
  ],

  "BOTTOM COVER|Bottom Dual Secondary Color|Bottom Cover Style": [
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~Fab~Bot-generic~__blockS.glb",
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~Fab~Rohi-NovParad~__blockS.glb",
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~Leath~Perr-Sky~__blockS.glb",
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~Leath~Perr-feathW~__blockS.glb",
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~Leath~Perr-Eli~__blockS.glb",
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~Leath~Muir-DFs~__blockS.glb",
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~Leath~Muir-DLs~__blockS.glb",
    "/400_DualTone_BottomCover_DS/bottomDressCoverDS__~simLeath~Tapi-UlGraph~__blockS.glb",
  ],

  "HEADREST COVER|Headrest Decorative Stitch|Headrest Decorative Stitch": [
    "/empty.glb",
    "/93_Mono_Tone_Head_Rest_Cover/headrestCover__~stitchingThread~__default.glb",
  ],

  "HEADREST COVER|Headrest Mono Primary Color|Headrest Cover Style": [
    "/410_MonoTone_Headrest_DS/headrestCoverDS__~Fab~Bot-generic~__block.glb",
    "/410_MonoTone_Headrest_DS/headrestCoverDS__~Fab~Rohi-NovParad~__block.glb",
    "/410_MonoTone_Headrest_DS/headrestCoverDS__~Leath~Perr-Sky~__block.glb",
    "/410_MonoTone_Headrest_DS/headrestCoverDS__~Leath~Perr-feathW~__block.glb",
    "/410_MonoTone_Headrest_DS/headrestCoverDS__~Leath~Perr-Eli~__block.glb",
    "/410_MonoTone_Headrest_DS/headrestCoverDS__~Leath~Muir-DFs~__block.glb",
    "/410_MonoTone_Headrest_DS/headrestCoverDS__~Leath~Muir-DLs~__block.glb",
    "/410_MonoTone_Headrest_DS/headrestCoverDS__~simLeath~Tapi-UlGraph~__block.glb",
    //
  ],

  "HEADREST COVER|Headrest Dual Primary Color|Headrest Cover Style": [
    "/411_DualTone_Headrest_DS/headrestCoverDS__~Fab~Bot-generic~__blockP.glb",
    "/411_DualTone_Headrest_DS/headrestCoverDS__~Fab~Rohi-NovParad~__blockP.glb",
    "/411_DualTone_Headrest_DS/headrestCoverDS__~Leath~Perr-Sky~__blockP.glb",
    "/411_DualTone_Headrest_DS/headrestCoverDS__~Leath~Perr-feathW~__blockP.glb",
    "/411_DualTone_Headrest_DS/headrestCoverDS__~Leath~Perr-Eli~__blockP.glb",
    "/411_DualTone_Headrest_DS/headrestCoverDS__~Leath~Muir-DFs~__blockP.glb",
    "/411_DualTone_Headrest_DS/headrestCoverDS__~Leath~Muir-DLs~__blockP.glb",
    "/411_DualTone_Headrest_DS/headrestCoverDS__~simLeath~Tapi-UlGraph~__blockP.glb",
  ],

  "HEADREST COVER|Headrest Dual Secondary Color|Headrest Cover Style": [
    "/411_DualTone_Headrest_DS/headrestCoverDS__~Fab~Bot-generic~__blockS.glb",
    "/411_DualTone_Headrest_DS/headrestCoverDS__~Fab~Rohi-NovParad~__blockS.glb",
    "/411_DualTone_Headrest_DS/headrestCoverDS__~Leath~Perr-Sky~__blockS.glb",
    "/411_DualTone_Headrest_DS/headrestCoverDS__~Leath~Perr-feathW~__blockS.glb",
    "/411_DualTone_Headrest_DS/headrestCoverDS__~Leath~Perr-Eli~__blockS.glb",
    "/411_DualTone_Headrest_DS/headrestCoverDS__~Leath~Muir-DFs~__blockS.glb",
    "/411_DualTone_Headrest_DS/headrestCoverDS__~Leath~Muir-DLs~__blockS.glb",
    "/411_DualTone_Headrest_DS/headrestCoverDS__~simLeath~Tapi-UlGraph~__blockS.glb",
  ],
  "HEADREST COVER|Antimacassar|Antimacassar": [
    "/empty.glb",
    "/125_Disposable_Plain/antimacassar__~Leath~Sp-FT4075~__default.glb",
  ],

  "SEAM STYLE|Funcional Seam|Funcional Seam": [
    "/72_Mono_Tone_Back_Dress_Cover/stitch__stitchTop__block.glb",
    "/141_Bottom_Stitch_None/stitch__stitchTop__block.glb",
    "/93_Mono_Tone_Head_Rest_Cover/stitch__stitchTop__block.glb",

    "/72_Mono_Tone_Back_Dress_Cover/stitch__stitchStandard__block.glb",
    "/141_Bottom_Stitch_None/stitch__stitchStandard__block.glb",
    "/93_Mono_Tone_Head_Rest_Cover/stitch__stitchStandard__block.glb",

    "/72_Mono_Tone_Back_Dress_Cover/stitch__stitchHexa__block.glb",
    "/141_Bottom_Stitch_None/stitch__stitchHexa__block.glb",
    "/93_Mono_Tone_Head_Rest_Cover/stitch__stitchHexa__block.glb",
  ],
};
